import { render } from "./VUEAppContentAggiungiMessaggio.vue?vue&type=template&id=79f7a594"
import script from "./VUEAppContentAggiungiMessaggio.vue?vue&type=script&lang=js"
export * from "./VUEAppContentAggiungiMessaggio.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__